import { config } from 'sierra-client/config/global-config'
import { useSelector } from 'sierra-client/state/hooks'
import { selectIsRestrictedUser } from 'sierra-client/state/user/user-selector'

export function useIsSidebarNavigationAllowed(): boolean {
  const isRestrictedUser = useSelector(selectIsRestrictedUser)
  return !isRestrictedUser && !config.scorm.isScorm
}
